/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_PresetsInputs */



/**
* | output |
* | --- |
* | "Export Presets" |
*
* @param {Export_PresetsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const export_presets = /** @type {((inputs?: Export_PresetsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_PresetsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter les préréglages")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export-Voreinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione dei preset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт предустановок")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar ajustes preestablecidos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートプリセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Predefinições de exportação")
	return /** @type {LocalizedString} */ ("Export Presets")
});